import React from 'react';
import { Box, Button, Icon, Tag } from '@neshane/blueberry';
import { CircuitStateBadge } from './StatusBadges';
import { PROVIDER_LABELS, formatDateTime } from '../labels';
import { useProviderHealthActions } from '../hooks';

const stateBg = {
    CLOSED: 'bg-secondary-success-default',
    OPEN: 'bg-secondary-alert-default',
    HALF_OPEN: 'bg-secondary-warning-default',
};

function ProviderHealthCard({ provider }) {
    const actions = useProviderHealthActions();
    const busy = actions.busyProvider === provider.provider;
    const enabled = provider.enabled !== false;
    const state = provider.state || 'CLOSED';
    const neverChecked = !provider.lastCheckedAt;

    return (
        <Box className="flex flex-col gap-12">
            <div className="flex items-center gap-16">
                <span className={`flex items-center justify-center rounded-12 p-8 ${neverChecked ? 'bg-secondary-default' : stateBg[state] || 'bg-secondary-default'}`}>
                    <Icon name="shield-star" size="m" />
                </span>
                <div className="flex flex-1 flex-col gap-4">
                    <p className="body-m text-primary">{PROVIDER_LABELS[provider.provider] || provider.provider}</p>
                    <p className="body-s text-secondary-bg-primary">
                        آخرین بررسی: {formatDateTime(provider.lastCheckedAt)}
                    </p>
                </div>
                {neverChecked ? (
                    <Tag variant="neutral">بررسی نشده</Tag>
                ) : (
                    <CircuitStateBadge state={state} />
                )}
            </div>

            {neverChecked && (
                <p className="body-s text-secondary-bg-primary">
                    هنوز هیچ بررسی‌ای برای این سرویس انجام نشده است؛ وضعیت آن تأیید نشده است.
                </p>
            )}

            {!neverChecked && provider.isStale && (
                <p className="body-s text-secondary-warning-default">
                    آخرین بررسی این سرویس بیش از ۱۵ دقیقه پیش انجام شده است.
                </p>
            )}

            {!enabled && (
                <p className="body-s text-secondary-alert-default">سرویس توسط ادمین غیرفعال شده است</p>
            )}

            <div className="flex flex-wrap gap-8">
                <Button
                    text="بستن مدار"
                    variant="secondaryBrand"
                    isDisabled={!enabled || state === 'CLOSED' || busy}
                    onClick={() => actions.close(provider.provider)}
                />
                <Button
                    text="قطع مدار"
                    variant="secondaryNeutral"
                    isDisabled={!enabled || state === 'OPEN' || busy}
                    onClick={() => actions.open(provider.provider)}
                />
                <Button
                    text={enabled ? 'غیرفعال کردن' : 'فعال‌سازی'}
                    variant="secondaryNeutral"
                    isLoading={busy}
                    isDisabled={busy}
                    onClick={() => actions.enable(provider.provider, !enabled)}
                />
            </div>
        </Box>
    );
}

export default ProviderHealthCard;